export default "__VITE_ASSET__b5f9a9a3__"